(function () {
    pagination(true);
})();

(function () {
    if (!document.body.classList.contains('post-template')) return;

    const cover = document.querySelector('.gh-cover');
    if (!cover) return;

    const image = cover.querySelector('.gh-cover-image');

    window.addEventListener('load', function () {
        cover.style.setProperty('--cover-height', image.clientWidth * image.naturalHeight / image.naturalWidth + 'px');
        cover.classList.remove('loading');
    });
})();

// Main navbar dropdown
class DropdownHandler {
    constructor(itemId, dropdownId) {
        this.item = document.getElementById(itemId);
        this.dropdown = document.getElementById(dropdownId);
        this.delayedTimeout = null; 
        this.setupEventListeners();
    }
    showDropdown() {
        this.dropdown.classList.remove("hidden");
    }
    hideDropdown() {
        this.dropdown.classList.add("hidden");
    }
    setupEventListeners() {
        this.item.addEventListener("mouseover", () => {
            clearTimeout(this.delayedTimeout);
            this.delayedTimeout = setTimeout(() => {
                this.showDropdown();
            }, 150);
        });
        this.item.addEventListener("mouseout", () => {
            clearTimeout(this.delayedTimeout);
            this.delayedTimeout = setTimeout(() => {
                this.hideDropdown();
            }, 100);
        });
    }
}
const productsDropdown = new DropdownHandler("products-item", "products-dropdown");
const solutionsDropdown = new DropdownHandler("solutions-item", "solutions-dropdown");
const integrationsDropdown = new DropdownHandler("integrations-item", "integrations-dropdown");
const resourcesDropdown = new DropdownHandler("resources-item", "resources-dropdown");
const companyDropdown = new DropdownHandler("company-item", "company-dropdown");


// Mobile nav
function toggleMobileNav() {
    var mobileNav = document.querySelector('.mobile-nav');
    if (mobileNav.classList.contains('open')) {
        mobileNav.classList.remove('open');
    } else {
        mobileNav.classList.add('open');
    }
}
document.addEventListener('DOMContentLoaded', function () {
    const hasDropdown = document.querySelectorAll('.has-dropdown');
    hasDropdown.forEach(item => {
        item.addEventListener('click', function () {
            const dropdown = this.querySelector('.dropdown-ul-mbl');
            const arrowBottom = this.querySelector('.arrow-bottom');
            const arrowTop = this.querySelector('.arrow-top');
            dropdown.style.display = (dropdown.style.display === 'block') ? 'none' : 'block';
            arrowBottom.style.display = (arrowBottom.style.display === 'none') ? 'inline' : 'none';
            arrowTop.style.display = (arrowTop.style.display === 'inline') ? 'none' : 'inline';
            hasDropdown.forEach(otherItem => {
                if (otherItem !== item) {
                    otherItem.querySelector('.dropdown-ul-mbl').style.display = 'none';
                    otherItem.querySelector('.arrow-top').style.display = 'none';
                    otherItem.querySelector('.arrow-bottom').style.display = 'inline';
                }
            });
        });
    });
});